import request from '@/utils/request';

export function getReviewList(params, silentRequest = false) {
  return request({
    url: '/Review/getExplore',
    params,
    silentRequest,
  });
}

export function getProductReviewData(targetType, targetId) {
  return request({
    url: '/Review/getProductData',
    params: {
      targetType,
      targetId,
    },
  });
}

export function createProductReview(targetType, targetId, starNum, content) {
  return request({
    url: '/Review/create',
    params: {
      targetType,
      targetId,
      starNum,
      content,
    },
  });
}
